<template>
  <router-view />
</template>

<script>
export default {
  name: "AdminContainer",
};
</script>